import React from 'react';
import './ViewSharedReport.css';
import { baseUrl, domain, partyBrands, partypoker_login_rurl } from '../../common/config.js';
import Loading from '../../Loading';
import { apiService } from '../../common/apiCallService';
import Header from '../../container/Header/Header.js';
import { PlayerLevel, ReportSummaryMessage, ReportCardContent } from 'mygame-components';
import { getColor, getDarkTextColor, getHoverColor, getImage, getTextColor } from '../../common/ThemeService';
import i18next from 'i18next'
import { saveActivity } from '../../common/commonService';
class ViewSharedReportCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reportObj: '',
            open:false,
            starListElem:[],
            loggedInType: localStorage.getItem('loggedInType')
        }
    }
    componentDidMount() {
        document.body.style.backgroundColor = window.innerWidth >=768 ? "rgb(250, 250, 250)":"rgb(255, 255, 255)";
        console.log("this.props.shareId",this.props.shareId);
        const  shareId  = this.props.shareId || this.props.match.params.shareId;
        apiService(baseUrl + '/shareLinkMetadata/findById',
            { id: shareId, medalDetails:true },
            (data) => {
                // console.log(data)
                this.setState({
                    reportObj: data
                })

            }, (err) => {
                console.log(err);
            })
    }
    redirectToRequiredPage = (type) => {
        if (type === 'login') {
            window.open(partypoker_login_rurl, "_self", "toolbar=yes,scrollbars=yes,resizable=yes");
        } else if (type === 'register') {
            window.location.href = "https://myaccount.partypoker.com/en/mobileportal/register?rurl=https:%2F%2Fwww.partypoker.com%2Fen%2Fmy-game";
        }
        else if (type === 'learnMore') {
            window.open('https://www.partypoker.com/en/my-game', "_self", "toolbar=yes,scrollbars=yes,resizable=yes");
        }
    }
    render() {
        const themeColor = getColor()
        const themeTextColor = getTextColor()
        const themeDarkTextColor = getDarkTextColor()
        const themeHoverColor = getHoverColor()
        console.log("ViewSharedReportCard");
        if (this.state.reportObj === '') {
            return <Loading />
        }

        const showModal = this.state.open ? 'displayBlock' : 'displayNone'

        const {starsDetails, medalsDetails, reportCardObject } = this.state.reportObj
        const { summeryRange, playerStats, gameType, hands, summaryInfo, luckfactor, accountName,
            lastReportUpdatedDate, playerName, star,  } = reportCardObject;
        const starListElem = [];
        if(starsDetails) {    
            starsDetails.map((starObj, i) => {
                starListElem.push(<div className="exp-level-div">
                    <span className="exp-level-span" key={"key" + i}>
                    {`Hands: ${starObj.min_hand} ${starObj.max_hand ? `- ${starObj.max_hand}` : ''}`}</span>
                    <img className="expStars" key={i}
                    style={{ height: 30,width:130 ,marginLeft: "-5px"}}
                    src={`${getImage("/images/Stars/",`/Star_${starObj.star}.png`)}`}
                /></div>);
            })
        }
        const logo = getImage("/images/logo/", ".png")
        return <div  className=''>
           {localStorage.getItem('token') &&   <Header/> }
           <style>
                    {`.levelInfo {\
                            background-color: ${themeColor} !important;\ 
                            border-color: ${themeColor} !important;\
                            color: ${themeTextColor} !important;\
                        }\
                    `}
                    {` a.mg-btn.saffron.liviviewLessonBtn.reportCardLessonLink {\
                            background-color: #ffffff !important;\ 
                            color: ${themeDarkTextColor} !important;\
                            border-color: ${themeColor} !important;\
                        }\
                    `}
                    {`.closeButtonhoverEffect:hover, a.mg-btn.saffron.liviviewLessonBtn.reportCardLessonLink:hover {\
                            background-color: ${themeHoverColor} !important;\ 
                        }\
                        `}
                    {`.levelInfo:hover {\
                            background-color: ${themeHoverColor} !important;\ 
                            color: ${themeDarkTextColor} !important;\
                        }\
                    `}
                </style>
        <div className="content-container" id="viewShareReportCardId" style={{ background: "#fff", marginTop: '0px' }}>
             {medalsDetails && <PlayerLevel
                    domain={domain}
                    showModal={showModal}
                    medalsDetails={medalsDetails}
                    starListElem={starListElem}
                    closeLevelInfo={() => { this.setState({ open: false }) }}
                />}
               
            <div className="container-header-page" style={localStorage.getItem('token') ?{boxShadow:'rgba(0, 0, 0, 0.09) 0px 2px 6px 2px', height: '324px'}:{ backgroundImage: `url(https://${domain}/images/skillLevel/skill_level_bg_${localStorage.getItem("loggedInType") === "Danskespil" ? "Danskespil" : "PartyPoker"}.jpg)` }}>
                <div className="container">
                   {!localStorage.getItem('token') && <div style={{position:"relative",top:"39px"}}>
                    <div className="container-header-content">
                        <div>
                                    <img data-e2e="myGameLogo" src={`/images/logo/${this.state.reportObj.attribute5}.png`} style={{ width: partyBrands.includes(this.state.loggedInType) ? '12em' : '8em', margin: '2rem' }} />
                        </div>
                        {/* <div className="container-header-subcontent">
                            <div className="register-div" onClick={() => this.redirectToRequiredPage('register')}>
                                Register
                            </div>
                            <div className="login-div" onClick={() => this.redirectToRequiredPage('login')}>
                                Log In
                            </div>
                        </div>  */}
                    </div>
                    <div className="mygame-description-div">
                        <div className="mygame-description-header">
                            Become the poker player you were born to be
                        </div>
                        <div className="mygame-description-content">
                            86% of new players improve using MyGame
                        </div>
                        {/* <div className="learn-more" onClick={() => this.redirectToRequiredPage('learnMore')}>
                            Learn More
                            </div> */}
                    </div>
                    </div>}
                    <div className="view-report-div" style={localStorage.getItem('token') ?{boxShadow:'none'}:{}}>
                        <div className="view-report-user-details">
                            <span>
                                {/* {this.state.name} {this.state.gameType} */}
                                {playerName + "'s"} {gameType} Game Report
                    </span>
                        </div>
                        <div className="view-report-game-details">
                            <div className="view-report-card-level-level-data" style={{ paddingTop: '15px' }}>
                                <img className='view-report-card-level-badge' data-e2e="medalImg"
                                    src={'//' + domain + '/images/Medals/'  + (partyBrands.includes(this.state.loggedInType) ? 'PartyPoker' + '/' + gameType : gameType) + '/' + summaryInfo.medal.replace(/[^A-Z0-9-]/ig, "") + '/' + summaryInfo.medal.replace(/[^A-Z0-9-]/ig, "") + '_' + star + '.png'} />
                            </div>
                            <div className="view-report-card-level-level-data" style={{ paddingTop: '25px' }}>
                                <span className="view-report-card-level-level-name1">
                                    Skill Level:  {summaryInfo.medal}
                                </span>
                                <span className="view-report-card-level-level-subDetails1">
                                    Overall Score: {summaryInfo.points}%
                                </span>
                                <span className="share-report-card-level-level-subDetails1">
                                    Hands Played: {hands}
                                </span>
                                <div className="actionButtons">
                                    <button className='shared-report-levelinfo-button' style={{backgroundColor: themeColor, color: themeTextColor}}
                                        data-e2e="levelInfo" onClick={() => { this.setState({ open: true }) }}>
                                        LEVEL INFO
                                    </button>
                                </div>
                            </div>
                            <div className="view-report-card-level-level-data" style={{ width: '587px', paddingTop: '15px' }}>
                                <ReportSummaryMessage i18next={i18next} summary={summaryInfo.comment} gameType={gameType} />
                            </div>
                        </div>
                    </div>
                    <div className="view-mygame-analysis-div">
                    <ReportCardContent
                        i18next={i18next}
                        gameType={gameType}
                        updatedAt={lastReportUpdatedDate}
                        handsAnalysed={hands}
                        // saveActivity={saveActivity}
                        summaryInfo={summaryInfo}
                        playerStatistics={playerStats}
                        summaryRange={summeryRange}
                        luckfactor={luckfactor}
                        accountName={accountName}
                        sharedReport={true}
                    />
                    </div>
                </div>
            </div>
        </div>
        </div>
        
    }
}

export default ViewSharedReportCard;


/** WEBPACK FOOTER **
 ** ./src/components/SharedReport/ViewSharedReportCard.js
 **/